import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AuthenticationService } from 'services';
import { Utils } from 'shared/helpers';
import { AuthActions } from 'state/authentication/Action';
import { BaseAppActions } from 'state/baseapplication/Action';
import {
  BaseApplicationState,
  Organization,
} from 'state/baseapplication/Reducer';
import jwt_decode from 'jwt-decode';

const OrgList: React.FC = () => {
  const [loadingOrgs, setLoadingOrgs] = useState(true);
  const navigate = useNavigate();
  const { orgs }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  const reduxDispatch = useDispatch();

  // API Calls
  const loadOrganisation = (): void => {
    setLoadingOrgs(true);
    AuthenticationService.getOrgList()
      .then((response) => {
        const { data } = response.data;
        reduxDispatch(BaseAppActions.setOrgsList(data));
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
        navigate('/login', { replace: true });
      });
  };

  const loadAccessToken = (org: Organization): void => {
    setLoadingOrgs(true);
    AuthenticationService.getOrgAccessToken({
      orgId: org.id,
    })
      .then((response) => {
        const { data } = response.data;
        const { accessToken } = data;
        const decoded: any = jwt_decode(accessToken);
        reduxDispatch(
          AuthActions.setLoginStatus({
            ...data,
            isUserLoggedIn: true,
            isOrgSelected: true,
            ...decoded,
          })
        );
        reduxDispatch(BaseAppActions.setActiveOrg(org));
        reduxDispatch(BaseAppActions.setOrgAclConfig(data.configs));
        navigate('/overview', { replace: true });
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
        navigate('/login', { replace: true });
      });
  };

  // UI Actions
  const actionSetOrganisation = (org: Organization): void => {
    loadAccessToken(org);
  };

  // Hooks
  useEffect(() => {
    if (orgs.length === 1) {
      actionSetOrganisation(orgs[0]);
    } else {
      setLoadingOrgs(false);
    }
  }, [orgs]);

  useEffect(() => {
    loadOrganisation();
  }, []);

  // UI Elements
  return (
    <>
      {loadingOrgs && (
        <Box className="center-content flex-column">
          <CircularProgress />
          <Typography variant="h2" className="mt-10 poppins-bold">
            Processing...
          </Typography>
        </Box>
      )}
      {!loadingOrgs && (
        <>
          <Typography className="mb-10" variant="h2">
            Select the account you want to use today
          </Typography>

          {orgs.map((org: Organization) => (
            <Box
              key={org.id}
              className="org-list"
              onClick={() => actionSetOrganisation(org)}
            >
              <Stack>
                <Typography className="org-name" variant="h3">
                  {org.name}
                </Typography>
                <Typography className="org-description" variant="body1">
                  {org.description}
                </Typography>
              </Stack>
              <img src="/images/icons/Nav.svg" alt="" />
            </Box>
          ))}
        </>
      )}
    </>
  );
};

export default OrgList;
